import { render, staticRenderFns } from "./entregas.vue?vue&type=template&id=54391ced"
import script from "./entregas.ts?vue&type=script&lang=js&external"
export * from "./entregas.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54391ced')) {
      api.createRecord('54391ced', component.options)
    } else {
      api.reload('54391ced', component.options)
    }
    module.hot.accept("./entregas.vue?vue&type=template&id=54391ced", function () {
      api.rerender('54391ced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/entregas/entregas.vue"
export default component.exports